module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/desktop_a1b846.jpg";